import * as services from './services'

/**
 * @des print 打印
 * @param rootStore
 * @param options {
 *  printcode: String 打印模板唯一标识
 *  ids: String 需要打印的数据集
 * }
 * @returns
 */
export async function print(rootStore: any, options: any = {}) {
  const { pageStore = {}, utils = {} } = rootStore
  const { params = {}, query = {} } = pageStore
  const { printcode = '', ids = [], dataSourceAlias = '' } = options
  console.log('params----print', params)
  if (!printcode) {
    utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80062', '请先选择打印模板'))
  }

  const queryData = {
    datasource: dataSourceAlias
  }

  const needParams = {
    query: {
      ...query,
      ...queryData,
      busiObj: options.busiObj || query.busiObj
    },
    data: {
      billno: params?.billNo,
      template: printcode,
      ids: ids.length > 0 ? ids : [params?.billId]
    }
  }
  const res = await services.print(needParams)
  if (res?.code !== 200) {
    return Promise.reject(res?.message)
  }
  const resData = res.data
  // 处理目标单据地址resultUrl
  const infoArr = resData.split('&')
  const getInfoArr = infoArr.filter((item: any) => item.indexOf('serverUrl') < 0)
  const resultUrl = getInfoArr.join('&')
  const tenantId = getUrlValue(res.data, 'tenantId')
  // 跳转打印服务
  window.open(`${location.origin}/iuap-apcom-print/u8cprint/design/getPreview?domainDataBaseByCode=${params?.domainKey}&tenantId=${tenantId}&meta=5&sendType=6&lang=zh_CN&printcode=${printcode}&serverUrl=${location.origin}${resultUrl}`)
  return res
}

const getUrlValue = function (url: String, kValue: String) {
  const reg = /([^?&=]+)=([^?&=]+)/g
  const obj = {}
  url.replace(reg, function () {
    obj[arguments[1]] = arguments[2]
  })
  for (const keyName in obj) {
    if (keyName === kValue) {
      return obj[keyName]
    }
  }
}
